import { render, staticRenderFns } from "./AppIntroPage.vue?vue&type=template&id=08b68268&scoped=true"
import script from "./AppIntroPage.vue?vue&type=script&lang=js"
export * from "./AppIntroPage.vue?vue&type=script&lang=js"
import style0 from "./AppIntroPage.vue?vue&type=style&index=0&id=08b68268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b68268",
  null
  
)

export default component.exports